import { useEffect, useState } from "react";
import GetServerAddress from "../../../../../functions/GetServerAddress";
import axios from "axios";
import { Get_One_From_MongoDB } from "../../../../api/Get_One_From_MongoDB";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function SEFText({ Attendee }) {
  const { logout } = StaffuseAuth();

  //--------------------------GET IP DATA--------------------------------

  const [EC, setEC] = useState({});
  useEffect(() => {
    if (
      Attendee.IPInfo?.EC_ID &&
      Attendee.IPInfo?.EC_ID !== "" &&
      Attendee.IPInfo?.EC_ID !== null &&
      Attendee.IPInfo?.EC_ID !== undefined
    ) {
      Get_One_From_MongoDB("IP", "EC", Attendee.IPInfo.EC_ID, setEC, logout);
    }
  }, [Attendee.IPInfo?.EC_ID]);

  const [Agencies, setAgencies] = useState({});
  useEffect(() => {
    if (
      EC.MetaData?.Agency_id &&
      EC.MetaData?.Agency_id !== "" &&
      EC.MetaData?.Agency_id !== null &&
      EC.MetaData?.Agency_id !== undefined
    ) {
      Get_One_From_MongoDB(
        "IP",
        "Agencies",
        EC.MetaData.Agency_id,
        setAgencies,
        logout
      );
    }
  }, [EC]);

  const [IP, setIP] = useState({});
  useEffect(() => {
    if (
      Agencies.MetaData?.IP_id &&
      Agencies.MetaData?.IP_id !== "" &&
      Agencies.MetaData?.IP_id !== null &&
      Agencies.MetaData?.IP_id !== undefined
    ) {
      Get_One_From_MongoDB(
        "Staff",
        "Users",
        Agencies.MetaData.IP_id,
        setIP,
        logout
      );
    }
  }, [Agencies]);
  //----------------------------Open SEF ------------------------------

  function handleGoToSEF(e) {
    e.preventDefault();
    console.log("yeet");
    if (Attendee?.MetaData?.Password) {
      localStorage.setItem("Student_id", Attendee?._id);
      console.log("localStorage");
      console.log(localStorage);
      window.open(
        `/Student/login/${Attendee._id}/${Attendee?.MetaData?.Password}`,
        "_blank"
      );
    } else {
      window.alert("No Password");
    }
  }

  return (
    <>
      <div style={{ width: "100%", display: "flex" }}>
        <div style={{ width: "50%" }}>
          <p>
            {Attendee.BasicInfo?.ProgrammeTitle
              ? Attendee.BasicInfo?.ProgrammeTitle
              : "..."}
            <br></br>
            <b>
              {Attendee.BasicInfo?.ProgrammeVarient
                ? Attendee.BasicInfo?.ProgrammeVarient.toLowerCase().includes(
                    "accom"
                  )
                  ? "Accom"
                  : "Non Accom"
                : "..."}
            </b>
            <br></br>
            {Attendee.BasicInfo?.ProgrammeDate === "(7th July - 18th July 2025)"
              ? "Young 1"
              : Attendee.BasicInfo?.ProgrammeDate ===
                "(28th July - 8th August 2025)"
              ? "Young 2"
              : Attendee.BasicInfo?.ProgrammeDate ===
                "(18th August - 29th August 2025)"
              ? "Young 3"
              : "..."}{" "}
            <br></br>
            {Attendee.IPInfo?.EC_ID &&
            Attendee.IPInfo?.EC_ID !== "" &&
            Attendee.IPInfo?.EC_ID !== null &&
            Attendee.IPInfo?.EC_ID !== undefined
              ? "EC Bookings"
              : "Non EC Bookings"}
            <br></br>
            EC: {EC.BasicInfo?.First_Name ? EC.BasicInfo?.First_Name : ""}{" "}
            {EC.BasicInfo?.Last_Name ? EC.BasicInfo?.Last_Name : ""}
            <br></br>
            Agency: {Agencies.BasicInfo?.Name
              ? Agencies.BasicInfo?.Name
              : ""}{" "}
            <br></br>
            IP: {IP.Username ? IP.Username : ""}{" "}
          </p>
        </div>
        <div style={{ width: "50%" }}>
          <p>
            {Attendee.BasicInfo?.First_Name} {Attendee.BasicInfo?.Last_Name}
            <br></br>
            {Attendee.SEFInfo?.SEFSubmissionDate
              ? Attendee.SEFInfo?.SEFSubmissionDate
              : "..."}
            <br></br>
            Assigned:{" "}
            {Attendee.SEFInfo?.Staff_Assigned
              ? Attendee.SEFInfo?.Staff_Assigned
              : "..."}
            <br></br>
            Username: {Attendee._id ? Attendee._id : "..."}
            <br></br>
            Password:{" "}
            {Attendee.MetaData?.Password ? Attendee.MetaData?.Password : "..."}
            <br></br>
            <button onClick={(e) => handleGoToSEF(e)}>Go To SEF</button>
          </p>
        </div>
      </div>
    </>
  );
}

export default SEFText;
